import { TVesselRecentSalesItem } from '../valueTypes';
import { AgGridReact } from 'ag-grid-react';
import { themeBalham } from 'ag-grid-enterprise';
import { ColDef, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { formatDateAsString, formatValueAsString } from '../../../utils/helpers';
import { useMemo } from 'react';
import ImoAndNameCellRenderer from '../../../shared/components/renderers/customCellRenderers/ImoAndNameCellRenderer';

export interface IVesselRecentSalesProps {
	vesselRecentSales: TVesselRecentSalesItem[] | [];
}

const RecentSales: React.FC<IVesselRecentSalesProps> = ({ ...props }) => {
	const options: Intl.DateTimeFormatOptions = {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	};

	const defaultColDef = useMemo<ColDef>(() => {
		return {
			flex: 1,
			filter: 'agTextColumnFilter',
		};
	}, []);

	const colDefs: ColDef<TVesselRecentSalesItem>[] = [
		// { headerName: 'IMO Number', field: 'imoNumber', floatingFilter: true },
		{
			headerName: 'IMO Number',
			field: 'imoNumber',
			floatingFilter: true,
			headerTooltip: 'IMO Number',
			cellRenderer: ImoAndNameCellRenderer,
			cellRendererParams: {
				fromComponent: 'recentSales',
			},
		},
		{
			headerName: 'Vessel Name',
			field: 'name',
			floatingFilter: true,
			cellRenderer: ImoAndNameCellRenderer,
			cellRendererParams: {
				fromComponent: 'recentSales',
			},
		},
		{
			headerName: 'Size',
			floatingFilter: true,
			valueGetter: (params: ValueGetterParams<TVesselRecentSalesItem, any>) =>
				formatValueAsString(params.data?.size, null, '', '', ' ' + params.data?.sizeUnit),
		},
		{ headerName: 'Country of Build', field: 'countryOfBuild', floatingFilter: true },
		{ headerName: 'Yard Tier', field: 'yardTier', floatingFilter: true },
		{ headerName: 'Age at Sale', field: 'ageAtSale', floatingFilter: true },
		{ headerName: 'Buyer', field: 'buyer', floatingFilter: true },
		{ headerName: 'Seller', field: 'seller', floatingFilter: true },
		{
			headerName: 'Sale Date',
			field: 'saleDate',
			floatingFilter: true,
			valueFormatter: (params: ValueFormatterParams<TVesselRecentSalesItem, any>) => formatDateAsString(params.value, options),
		},
		{
			headerName: 'Sale Price',
			floatingFilter: true,
			valueGetter: (params: ValueGetterParams<TVesselRecentSalesItem, any>) =>
				`${formatValueAsString(params.data?.salePrice, { minimumFractionDigits: 2, maximumFractionDigits: 2 }, '', '$', ' Mn')}`,
		},
		{ headerName: 'Notes', field: 'notes', floatingFilter: true },
	];

	const rowData = props.vesselRecentSales ? props.vesselRecentSales : [];

	return (
		<div className="w-full h-full">
			<AgGridReact columnDefs={colDefs} rowData={rowData} theme={themeBalham} defaultColDef={defaultColDef} />
		</div>
	);
};

export default RecentSales;
